// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import FeaturesTopClass from '../_raw/features/icon_features_top_class.svg';
import withIconProps from '../withIconProps';

export default withIconProps(FeaturesTopClass, { shouldSetDefaultSize: false });
